import { Link, useHistory } from "react-router-dom";
import { Container } from "@remo-co/ui-core/src/components/Container";
import { Select } from "@remo-co/ui-core/src/components/Select";
import { useTheme } from "@remo-co/ui-core/src/hooks/useTheme";
import { FormControlLabel } from "@remo-co/ui-core/src/components/FormControlLabel";
import { Radio } from "@remo-co/ui-core/src/components/Radio";
import { useStyles } from "./styles";

export interface IStep {
  title: string;
  visible: boolean;
}

interface ISettingsLeftMenuProps {
  onSetActiveStep: (index: string) => void;
  activeStep: string;
  steps: Record<string, IStep>;
}

const MobileDropdown = ({
  onSetActiveStep,
  activeStep,
  steps,
}: ISettingsLeftMenuProps) => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <Container className={classes.selectorMobile} bottom="sm">
      <Select
        fullWidth
        name="Tabs"
        value={activeStep}
        onChange={(option: string) => {
          onSetActiveStep(option);
          history.push(`/account-settings/${option}`);
        }}
        options={Object.entries(steps)
          .filter(([, step]) => step.visible)
          .map(([key, step]) => ({
            value: key,
            key,
            disabled: key === activeStep,
            label: step.title,
          }))}
      />
    </Container>
  );
};

export const SettingsLeftMenu = ({
  onSetActiveStep,
  activeStep,
  steps,
}: ISettingsLeftMenuProps) => {
  const classes = useStyles();
  const theme = useTheme();

  const handleSetActiveStep = (i: string) => () => onSetActiveStep(i);

  return (
    <>
      <MobileDropdown
        onSetActiveStep={onSetActiveStep}
        activeStep={activeStep}
        steps={steps}
      />
      <div className={classes.settingsLeftMenuContainer}>
        <div className={classes.menu}>
          {Object.keys(steps).map((id) => {
            const { visible, title } = steps[id];

            return visible ? (
              <Link
                key={id}
                to={`/account-settings/${id}`}
                style={{
                  color:
                    id === activeStep
                      ? theme.palette.primary.main
                      : theme.palette.text.primary,
                }}
              >
                <FormControlLabel
                  value={id}
                  control={<Radio color="primary" className={classes.radio} />}
                  label={title}
                  labelPlacement="start"
                  checked={id === activeStep}
                  className={id === activeStep ? "checked" : ""}
                  onClick={handleSetActiveStep(id)}
                />
              </Link>
            ) : null;
          })}
        </div>
      </div>
    </>
  );
};
